module.exports = __webpack_public_path__ + "../resources/img/ic_arrow_left_disabled.ea7f286e.svg";